import { ApiSupportClient } from "../api-support.client";
import {
  UploadImageRequest,
  UploadImageResponse,
  UploadVideoRequest,
  UploadVideoResponse,
} from "./types";

const FilesApi = {
  uploadImage(body: UploadImageRequest) {
    return ApiSupportClient.post<UploadImageRequest, UploadImageResponse>(
      `/files/image/upload`,
      body
    );
  },
  uploadVideo(body: UploadVideoRequest) {
    return ApiSupportClient.post<UploadVideoRequest, UploadVideoResponse>(
      `/files/video/upload`,
      body
    );
  },
};

export { FilesApi };
